import { FsPeriod, FsType, FsTypeBase, isFsType } from '@types';
import { useCallback, useEffect } from 'react';
import { getAllFsPeriods } from '../networking';
import { useFsTypes } from './useFsTypes';

const convertPeriodToFsTypeBase = (result: FsPeriod[]) =>
  result.reduce(
    (unique, item) => [...unique].concat(isFsType(item.text) && unique.find((u) => u.text === item.text) ? [] : (item as FsTypeBase<FsType>)),
    [] as FsTypeBase<FsType>[]
  );

export function useTypeDropDownControl() {
  const { types, setTypes, typeId, setTypeId, type } = useFsTypes<FsType>();
  useFetchTypes(setTypes);

  return {
    type,
    typeId,
    setTypeId,
    types,
    isLoading: types.length === 0,
  };
}

function useFetchTypes(setTypes: (types: FsTypeBase<FsType>[]) => void) {
  const getTypes = useCallback(async () => {
    const result = await getAllFsPeriods();
    const types = convertPeriodToFsTypeBase(result);
    setTypes(types);
  }, []);

  useEffect(() => {
    getTypes();
  }, [getTypes]);
}
